import React from 'react';
import { Users, ArrowRight } from 'lucide-react';
import { Button } from '@/components/Button';

interface BannerSlideProps {
    isLoggedIn: boolean;
}

export const ReferralBannerSlide: React.FC<BannerSlideProps> = ({ isLoggedIn }) => {
    return (
        <div className="w-full shrink-0 flex flex-col md:flex-row items-center gap-6 px-4">
            <div className="flex relative z-10 shrink-0 group-hover:scale-105 transition-transform duration-500">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-indigo-400 to-indigo-600 flex items-center justify-center border-4 border-white dark:border-gray-900 shadow-2xl relative">
                    <Users className="w-10 h-10 md:w-14 md:h-14 text-white drop-shadow-md" />
                </div>
            </div>
            <div className="flex-1 text-center md:text-left z-10 mt-4 md:mt-0">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-gradient-to-r from-indigo-500/10 to-indigo-500/10 border border-indigo-500/20 rounded-full text-indigo-600 dark:text-indigo-400 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-3">
                    <Users className="w-3.5 h-3.5 fill-current" />
                    Indique e Ganhe
                </div>
                <h3 className="text-xl md:text-2xl font-black text-gray-900 dark:text-white mb-2 leading-tight">
                    Convide e Ganhe 8.000 Pontos!
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 font-medium mb-5 text-balance">
                    Traga seus amigos para o Radar da Economia. Você ganha 8.000 pontos a cada amigo que se cadastrar e começar a usar!
                </p>
                <div className="flex items-center justify-center md:justify-start">
                    <Button
                        variant="primary"
                        className="bg-gradient-to-r from-indigo-500 to-indigo-600 hover:from-indigo-600 hover:to-indigo-700 shadow-lg shadow-indigo-500/25 border-0 text-sm px-6 py-2.5 whitespace-nowrap group"
                    >
                        {isLoggedIn ? 'Convidar Amigos' : 'Convidar Amigos'}
                        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                </div>
            </div>
        </div>
    );
};
